import React from "react";
import { useSelector } from "react-redux";
import { Badge, Button, ButtonGroup, IconButton, Tooltip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import LibraryBooksIcon from "@material-ui/icons/LibraryBooks";
import { Email } from "@material-ui/icons";
import AddIcon from "@material-ui/icons/Add";
import { updateSidebar, updateNewMessageUi } from "../../../components/common/StoreCommon";
import { setNewFeedPostVisibilityInStore } from "../../../components/common/StoreFeedUi";
import { getNewFeedPostOpen } from "../../../store/ui/boomFeed";

export default function ViewToggle({ view, feedCount, inboxCount }) {
  const classes = useStyles();
  const feedOpen = useSelector(getNewFeedPostOpen)();

  const setView = (newView) => {
    if (view !== newView) {
      updateSidebar({ view: newView, open: true });
    }
  };

  const handleAdd = () => {
    if (view === "Feed") {
      setNewFeedPostVisibilityInStore(!feedOpen);
    } else {
      updateNewMessageUi();
    }
  };

  return (
    <div className={classes.container}>
      <ButtonGroup
        size="small"
        className={classes.viewToggle}
        aria-label="Feed or Inbox"
      >
        <Button
          startIcon={<LibraryBooksIcon fontSize="small" />}
          className={
            view === "Feed"
              ? `${classes.toggleButton} ${classes.toggleButtonSelected}`
              : classes.toggleButton
          }
          onClick={() => setView("Feed")}
        >
          <Badge
            badgeContent={feedCount}
            color="secondary"
            overlap="rectangular"
            className={classes.badge}
          >
            Feed
          </Badge>
        </Button>
        <Button
          startIcon={<Email fontSize="small" />}
          className={
            view === "Inbox"
              ? `${classes.toggleButton} ${classes.toggleButtonSelected}`
              : classes.toggleButton
          }
          onClick={() => setView("Inbox")}
        >
          <Badge
            badgeContent={inboxCount}
            color="secondary"
            overlap="rectangular"
            className={classes.badge}
          >
            Inbox
          </Badge>
        </Button>
      </ButtonGroup>

      <Tooltip title={view === "Feed" ? "New Post" : "New Message"}>
        <IconButton
          className={classes.addButton}
          onClick={handleAdd}
          aria-label={view === "Feed" ? "New Post" : "New Message"}
        >
          <AddIcon />
        </IconButton>
      </Tooltip>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    height: 64,
    minHeight: 64,
    maxHeight: 64,
    padding: theme.spacing(0, 1.5),
    background: "#fff",
    borderBottom: "1px solid #eee",
    boxSizing: "border-box",
  },
  viewToggle: {
    boxShadow: "none",
    width: "auto",
  },
  toggleButton: {
    textTransform: "none",
    fontWeight: 700,
    fontSize: "16px",
    padding: theme.spacing(0.5, 1.25),
    minWidth: 0,
    color: "rgb(135, 131, 131)",
    borderColor: "rgb(185, 181, 181)",
    backgroundColor: "white",
    "& .MuiButton-startIcon": {
      marginRight: 4,
    },
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.04)",
    },
  },
  toggleButtonSelected: {
    color: theme.palette.primary.main,
    backgroundColor: "rgba(25, 118, 210, 0.08)",
    borderColor: theme.palette.primary.main,
    "&:hover": {
      backgroundColor: "rgba(25, 118, 210, 0.12)",
    },
  },
  badge: {
    "& .MuiBadge-badge": {
      right: -10,
      top: 2,
    },
  },
  addButton: {
    color: "rgb(135, 131, 131)",
    padding: theme.spacing(1),
  },
}));
